import { useContext } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'

import { ModalContext } from '@/contexts/ModalContext'
import ModalAuth from '@/components/modals/ModalAuth'
import { authActions } from '@/redux/actions'

export default function useAuth() {
	const dispatch = useDispatch()
	const userAuth = useSelector(state => state.auth, shallowEqual)
	const { modalMount } = useContext(ModalContext)

	const checkAuthentication = () => {
		return userAuth.logged
	}

	const userHasRole = (roles) => {
		const rolesList = typeof roles === 'string' ? [roles] : roles
		const matchRoles = rolesList.filter((element) => userAuth?.account?.roles?.includes(element))
		return !_.isEmpty(matchRoles)
	}

	const authenticate = async (view = '/', viewParams = {}) => {
		return new Promise((resolve, reject) => {
			modalMount(
				<ModalAuth
					disableBackdropClick
					authView={view}
					authViewParams={viewParams}
					onAuth={async () => {
						await dispatch(authActions.getAccountDetails())
						resolve()
					}}
					onClose={reject}
				/>
			)
		})
	}

	const logout = async () => {
		return dispatch(authActions.logout())
	}

	return {
		authenticate,
		userHasRole,
		checkAuthentication,
		logout
	}
}
